import React, { useState, useEffect, useCallback } from 'react';
import { END_URL } from "../../config";
import './PersonalityResultHistory.css';
import { useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight ,faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import buttonloader from "../../images/buttonloader.gif";
import loadimg from "../../images/loader_wish.gif";
import Subscriptions from '../Subscriptions/Subscriptions';

function PersonalityResultHistory({free_test_slug,onLoginChange,userdetail}) {
  const [results, setResults] = useState([]);

  const [type,setType] = useState("");

  const [upsell,setUpsell] = useState(false);

  const [FreeResult,setFreeResult] = useState(false);

  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const { slug, test_slug } = useParams();
  const [hasSubscription, setHasSubscription] = useState(false);
  const [hasplan, setHasPlan] = useState({});
  const user = localStorage.getItem('user');
  const [isLoading, setIsLoading] = useState(true);

  const [ButtonLoad, setButtonLoad] = useState(false);

  const [testMutiple, settestMutiple] = useState(false);

  const [TestHeading, setTestHeading] = useState([]);

  const [TestLink, setTestLink] = useState(null);

  const [TestLinkValue, setTestLinkValue] = useState("");

  const [RetakeLabel, setRetakeLabel] = useState("");

  const subS = true;

  const [subscription, setSubscription] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const handleNavigete = (link) => {

    if (link) {
      window.location.href = `/test/${link}`;
    }
  };

  const fetchUserResult = useCallback(async () => {

    setIsLoading(true);

    try {
      let url = `${END_URL}/user-resulthistory`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          test_slug: slug,
        }),
      });

          const data = await response.json();

          const mappedResults = data?.data?.map(item => ({
            id: item.id,
            personalityType: {
              name: item.name || item.personalityType?.name || "Unknown",
              code: item.personalityType?.code || "N/A"
            },
            data: item.categoryresult?.map(cat => ({
              letter: cat.letter,
              left_result: cat.left_result,
              leftlabel: cat.resultcategory?.left_label,
              right_result: cat.right_result,
              rightlabel: cat.resultcategory?.right_label
            })) || [],
            testDate: item.created_at, // <-- Updated: use created_at
            result: item.result,
            dimension: item.dimension || null,
            cluster: item.cluster || null,
            test_slug: item.test_slug,
            test_type:item.type,
            test_subscription:item.test_done_subscription

          })) || [];

            setRetakeLabel(data?.re_take_test_label);

            setTestLink(data?.test_retake_subcription);

            setTestLinkValue(data?.test_retake_subcription_value);

            setResults(mappedResults);

            setType(data?.test?.type);

            setUpsell(data?.test?.up_sell);

            setFreeResult(data?.test?.free_result);

            setTestHeading(data?.test_categorys);

            setIsLoading(false);

            console.log("Results with dimension:", mappedResults);
          } catch (error) {
            console.error("Error fetching result:", error);
          }
  }, [token, slug]);


  const handleSub = async (subJson) => {
  
      try {
  
        let subIds = [];
    
          if (typeof subJson === "string") {
            try {
              subIds = JSON.parse(subJson);
            } catch (e) {
              console.error("Invalid JSON string for subIds:", e);
              return;
            }
          } else if (Array.isArray(subJson)) {
            
            subIds = subJson;
          }
  
          setShowModal(true);
  
          const res = await axios.post(
            `${END_URL}/sub_adver`,
            { ids: subIds },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
          setSubscription(res.data);
  
          localStorage.removeItem("pendingSubIds");
  
        } catch (err) {
          
          console.error("Error loading subscriptions:", err);
        }
    };


    useEffect(() => {
      const checkSlugSubscription = async () => {
        try {
          const response = await axios.get(`${END_URL}/subscription/check/${slug}/${test_slug}`, {
            headers: { Authorization: `Bearer ${token}` }
          });

          setHasSubscription(response.data.has_subscription);

          settestMutiple(response.data.test_multiple);

          setHasPlan(response.data.plan);

        } catch (error) {
          setHasSubscription(false);
        }
      };

      checkSlugSubscription();
    }, [user,token]);
  

   const HandlePayment = (item) =>
                 {
                             
                     const InitializePayment = async () => {
             
                         try {
                          
                           setButtonLoad(true);
                 
                             const response = await fetch(`${END_URL}/test-payment`, {
                 
                                 method: "POST",
                                 headers: {
         
                                     Authorization: `Bearer ${token}`,
                                     "Content-Type": "application/json",
                                 },
                 
                                 body: JSON.stringify(item)
         
                             });
                 
                             const data = await response.json();
         
                             console.log(data.payment,'fetch data');
                               
         
                             if (data.payment) {
         
                                 setButtonLoad(false);
                                 window.location.href = data.payment;
         
                             } else {

                                 setButtonLoad(false);

                                 console.error("Invalid response:", data);
                                 alert("An error occurred while processing the request.");
                             }
                 
                         } catch (error) {
                 
                             console.error("Error sending result:", error);
                         }
                     };
             
                     InitializePayment();
             
                 };
       


                 
  useEffect(() => {
    fetchUserResult();
  }, [fetchUserResult]);

const [confirmDeleteId, setConfirmDeleteId] = useState(null);

const handleDeleteClick = (id) => {
  setConfirmDeleteId(id); 
};


// const confirmDelete = async (id) => {

//     try {
//       const response = await fetch(`${END_URL}/test-result/${id}`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('token')}`,
//           "Content-Type": "application/json",
//         },
//       });
//       const data = await response.json();
//       if (!response.ok) throw new Error(data.error || "Failed to delete");
//       // Optionally, refresh the results list or update state
//       setResults(results.filter(result => result.id !== id));
//     } catch (error) {
//       console.error("Error deleting result:", error);
//       // Optionally, show an error message to the user
//     }

// };

const confirmDelete = async () => {
  try {
    const response = await fetch(`${END_URL}/test-result/${confirmDeleteId}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || "Failed to delete");
    setResults(results.filter((result) => result.id !== confirmDeleteId));
    setConfirmDeleteId(null); // close modal
  } catch (error) {
    console.error("Error deleting result:", error);
  }
};  

function formatDate(dateString) {
  const date = new Date(dateString);
  
  const day   = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year  = date.getFullYear();
  
  return `${day}-${month}-${year}`;
}


  const ResultRow = ({ result,test_subscription,test_type, onDelete }) => (
    <tr className="result-row">
        <td className="personality-type-cell">
          <span
            className="personality-type-link"
            onClick={() =>
              navigate(
                test_subscription
                  ? (
                      slug === free_test_slug
                        ? `/final/${slug}/${result.test_slug || result.id}`
                        : `/result/user/${slug}/${result.test_slug || result.id}`
                    )
                  : (
                      `/result/${slug}/${result.test_slug || result.id}`
                    )
              )
            }
            style={{ cursor: 'pointer' }}
          >
            {result.dimension?.name} ({result.result})
          </span>
        </td>

        <td className="personality-type-cell">

            <span
              className={`personality-type-link ${test_subscription ? 'green-result' : 'red-result'}`}
              onClick={() =>
                navigate(
                  test_subscription
                    ? (
                        slug === free_test_slug
                          ? `/final/${slug}/${result.test_slug || result.id}`
                          : `/result/user/${slug}/${result.test_slug || result.id}`
                      )
                    : (
                        `/result/${slug}/${result.test_slug || result.id}`
                      )
                )
              }
              style={{ cursor: 'pointer' }}
          >
              {test_subscription ? "View Full Result" : "Unlock Result" }
          </span>

        </td>

      {result.data.map((dim, i) => {
        const isLeft = dim.letter === "left";
        const trait = isLeft ? dim.leftlabel : dim.rightlabel;
        const percentage = Math.round(isLeft ? dim.left_result : dim.right_result);
        return (
          <td key={i} className="trait-cell">
            <span className="trait-percentage">{percentage}%</span>
            <span className={`trait-name ${isLeft ? 'selected-left' : 'selected-right'}`}>
              {trait}
            </span>
          </td>
        );
      })}
    <td className="date-cell">
 {formatDate(result.testDate)}
</td>

      <td className="actions-cell">
        <div className="action-buttons">
          <button
            className="action-btn delete-btn"
            onClick={() => handleDeleteClick(result.id)}
          >
            Delete
          </button>
        </div>
      </td>
    </tr>
  );

  const ResultsTable = ({ results, onDelete }) => (
    <div className="table-container">
      <table className="results-table">
        <thead>
          <tr>
            <th>Personality Type</th>
            <th>See Result</th>
            {[...Array(results[0]?.data?.length || 0)].map((_, i) => (
              <th key={i}>{TestHeading[i]?.left_label} / {TestHeading[i]?.right_label}</th>
            ))}
            <th>Test taken</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {results.map((result) => (
            <ResultRow key={result.id} test_subscription={result.test_subscription} result={result} test_type={result.type} onDelete={onDelete} navigate={navigate}
              slug={slug} />
          ))}
        </tbody>
      </table>
    </div>
  );

  const ConfirmModal = ({ message, onConfirm, onCancel }) => (
        <div className="modal-question history-modal">
          <div className="modal-test">
            <div className="modal-content-test">
              <div className="modal-dymic">{message}</div>
              <button className="modal-close-button-test" onClick={onConfirm}>
                Yes
              </button>
              <button className="modal-close-button-test" onClick={onCancel}>
                No
              </button>
            </div>
          </div>
        </div>
      );



  return (
    <div className="personality-result-history">
      <main className="main-content">

          { isLoading ? (

                <div className="loader-container">

                    <img src={loadimg} alt="Loading..." className="loader-gif" />

                </div>

            ) : (

              <div className="container">

                    <div className="content-section">

                      <button className="retake-test-btn back-button" onClick={() => navigate(-1)}>
                       <span> <FontAwesomeIcon icon={faArrowLeft} /></span>
                        <span>Back</span>
                    </button>

                      <h1 className="page-title">Result History</h1>
                      <ResultsTable results={results} onDelete={handleDeleteClick} />

                      {confirmDeleteId && (

                          <ConfirmModal
                            message="Are you sure you want to delete this test result?"
                            onConfirm={confirmDelete}
                            onCancel={() => setConfirmDeleteId(null)}
                          />
                      )}

                      <div className="retake-test-section">

                      {/* {type === 'free_test' && (
                        <button
                          className="retake-test-btn"
                          onClick={() => navigate(`/test/${free_test_slug}`)}
                        >
                          Retake the Test
                          <span>
                            <FontAwesomeIcon className="icc" icon={faArrowRight} />
                          </span>

                        </button>
                      )}

                        {type === 'paid' && (

                               !hasSubscription ? (

                                    testMutiple ? (

                                        <button className="retake-test-btn"   onClick={() => navigate(`/top-tier-subscriptions`)} >
                                        
                                                Retake the Test  {!ButtonLoad && <span>  <FontAwesomeIcon className="icc" icon={faArrowRight} /> </span> } {ButtonLoad && <img src={buttonloader} alt="Loading" style={{ marginLeft: '0px', width: '33px', height: '33px' }} /> }

                                        </button>

                                    ):(

                                        <button className="retake-test-btn"  onClick={() => HandlePayment(hasplan)} >
                                        
                                                Retake the Test {!ButtonLoad && <span>  <FontAwesomeIcon className="icc" icon={faArrowRight} /> </span> }  {ButtonLoad && <img src={buttonloader} alt="Loading" style={{ marginLeft: '0px', width: '33px', height: '33px' }} /> }

                                        </button>
                                    )


                                ) : (
                              
                                      <button className="retake-test-btn"   onClick={() =>navigate(`result/user/${slug}/start`)}>
                                      
                                              Retake the Test {!ButtonLoad && <span>  <FontAwesomeIcon className="icc" icon={faArrowRight} /> </span> }  {ButtonLoad && <img src={buttonloader} alt="Loading" style={{ marginLeft: '0px', width: '33px', height: '33px' }} /> }

                                      </button>
                          ))} */}
                             
                          {slug != free_test_slug ? (
                              <button className="retake-test-btn"
                              
                                  onClick={

                                        FreeResult ? (

                                          upsell
                                            ? (
                                                () => handleNavigete(`test/${slug}`)
                                              )
                                            : (
                                                () => handleNavigete(slug)
                                              )
                                              
                                        ):(

                                           upsell
                                            ? (
                                                TestLink !== "" && TestLink != null
                                                    ? () => handleNavigete(`test/${TestLink?.slug}`)
                                                    : () => handleSub(TestLinkValue)
                                              )
                                            : (
                                                TestLink !== "" && TestLink != null
                                                    ? () => handleNavigete(TestLink?.slug)
                                                    : () => handleSub(TestLinkValue)
                                              )
                                        )
                                       
                                    }
                                >
                                      {RetakeLabel}  

                                      <span>
                                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                      </span>
                              </button>
                              
                          ) : (
                            
                              <button className="retake-test-btn"
                                    onClick={
                                        () => handleNavigete(free_test_slug)
                                      }
                                >
                                      {RetakeLabel}  

                                      <span>
                                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                      </span>
                              </button>
                          )}
              
                      </div>
                    </div>
              </div>

          )}

            {ShowModal && (
                                      
                  <div 
                  className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
                   subscription?.data?.length == 1 ? "single-subscription" : ""
                  }`}
                
                >

                      <div className="newdashpop-inner">

                          <div className="newdashpop-container">

                              <button
                                className="newdashpop-close"
                                onClick={() => setShowModal(false)}
                                >
                                &times;
                            </button>

                            <div className="conent-pop">
                            
                              <Subscriptions subs={subS} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                            </div>

                          </div>

                      </div>

                  </div>
              )}

      </main>
    </div>
  );
}

export default PersonalityResultHistory;
